'use strict';

angular.module('shop').controller('ProductsController',
	function ($scope, $state, ShopService, CustomerService, $location) {
		$scope.loading = true;

		ShopService.getProducts().then(function (products) {
			if (products && products.searchGroupsAll) {
				$scope.categories = products.searchGroupsAll.reverse();

				if ($state.params['category']) {
					var index = parseInt($state.params['category']);
					var category = products.searchGroupsAll[index];
					$scope.activeCategory = category && category.searchGroup;
				}
			}
			if (products && products.shopArticles) {
				$scope.products = products.shopArticles;
			}
			$scope.loading = false;
		});

		var url = $location.absUrl();
		if (url.includes('/mypage/')) {
			CustomerService.get().then(function (customer) {
				$scope.points = customer.loyaltyPoints;
				$scope.kronor = Math.floor((customer.loyaltyPoints / 50));
			});
		}


		ShopService.getShopDeliveryDate().then(function (deliveryDate) {
			$scope.deliveryDate = deliveryDate;
		});

		$scope.setActiveCategory = function (category) {
			$scope.activeCategory = category && category.searchGroup;
		};

	});
